import React from 'react';

const BigmenuGroceryApp = () => {
  return (
    <div style={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
      <iframe
        src="/projectList/bigmenu.html"
        title="Bigmenu Grocery App"
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
     
    </div>
    
  );
}

export default BigmenuGroceryApp;